/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_Skill_BuilderInputs */

const en_mk_mx_skill_builder = /** @type {(inputs: Mk_Mx_Skill_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build a Skill with AI help`)
};

const id_mk_mx_skill_builder = /** @type {(inputs: Mk_Mx_Skill_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bangun Skill dengan bantuan AI`)
};

/**
* | output |
* | --- |
* | "Build a Skill with AI help" |
*
* @param {Mk_Mx_Skill_BuilderInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_skill_builder = /** @type {((inputs?: Mk_Mx_Skill_BuilderInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_Skill_BuilderInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_skill_builder(inputs)
	return en_mk_mx_skill_builder(inputs)
});